import { Dispatch, SetStateAction, useEffect, useRef } from 'react'

import { Article } from 'interfaces/types'

import { getArticleBySlug } from './utils'

export const PromoteArticleMap: Record<string, string[]> = {
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/suc-khoe-be-so-sinh/tre-hay-om-vat/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/suc-khoe-gia-dinh/cac-tu-the-quan-he-tren-ghe-tinh-yeu/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/suc-khoe-tre-em/van-de-tieu-hoa-o-tre/tre-bi-tieu-chay-7-dieu-me-can-biet/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cham-soc-be-so-sinh/tre-sinh-mo-va-sinh-thuong-co-gi-khac-biet/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/suc-khoe-gia-dinh/tu-the-69-trong-quan-he/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/suc-khoe-be-so-sinh/dau-bung-o-tre-so-sinh-nguyen-nhan-trieu-chung-va-cach-dieu-tri/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/suc-khoe-gia-dinh/36-tu-the-quan-he-vo-chong-3d/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/nuoi-day-con-cai/hat-giong-tam-hon/truyen-ke-cho-be-truoc-khi-di-ngu/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/lam-gi-khi-sua-me-chua-ve/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/duy-tri-nguon-sua-khi-me-di-lam/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/suc-khoe-gia-dinh/hon-nguc-nhu-the-nao/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/tinh-cam-gia-dinh/loi-an-ui-khi-nguoi-than-mat/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cot-moc-phat-trien-be-so-sinh/can-nang-va-chieu-cao-cua-con-the-nao-la-chuan/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/tinh-cam-gia-dinh/cach-lam-phu-nu-len-dinh/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/su-phat-trien-cua-tre/suc-khoe-tre-em/van-de-suc-khoe-tre-em-khac/cach-tang-de-khang-cho-be/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/mang-thai/chuyen-da-sinh-no/kinh-nghiem-huu-ich-khi-de-mo-khan-cap/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/giai-tri/vui-cuoi-tuan-xem-boi-kinh-nguyet/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/suc-khoe-gia-dinh/tu-the-quan-he-doggy/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/gia-dinh/tinh-cam-gia-dinh/dan-ong-thich-gi-khi-quan-he/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
  // '/mang-thai/don-con-chao-doi/tuoi-giap-tuat-sinh-con-nam-2025/': [
  //   '/su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu/cach-kich-sua/',
  // ],
}

export const usePromoteArticles = ({
  locale,
  setArticles,
  articles,
}: {
  locale: string
  setArticles: Dispatch<SetStateAction<Article[]>>
  articles: Article[]
}) => {
  const fetchingForRef = useRef<string[]>([])
  const fetchArticleAndInsertAfterId = async (
    permalinks: string[],
    afterId: string,
  ) => {
    if (locale !== 'vi-VN' || !setArticles) return
    permalinks.map((permalink) => {
      getArticleBySlug({ slug: permalink }).then((res) => {
        if (res) {
          setArticles?.((articles) =>
            articles.reduce<Article[]>((acc, article, index) => {
              const nextArticle = articles[index + 1]
              const skipIds = articles
                .reduce<Array<string>>(
                  (previousValue, currentValue) =>
                    previousValue.concat(String(currentValue.id)),
                  [],
                )
                .join(',')
              res.nextArticle = res.relatedArticles?.filter(
                (related) => !skipIds.includes(String(related.id)),
              )[0]
              if (res.nextArticle?.id) {
                res.relatedArticles = res.relatedArticles?.filter(
                  (related) => related.id !== res.nextArticle?.id,
                )
              }
              if (
                String(article.id) === String(afterId) &&
                (!nextArticle || nextArticle.permalink !== permalink)
              ) {
                return acc.concat([article, res])
              }
              return acc.concat(article)
            }, []),
          )
        }
        fetchingForRef.current = fetchingForRef.current.filter((id) => {
          return id !== afterId
        })
      })
    })
  }

  useEffect(() => {
    if (locale === 'vi-VN') {
      articles.forEach((article, index) => {
        const foundMappings = PromoteArticleMap[article.permalink]
        const nextArticle = articles[index + 1]
        if (
          foundMappings &&
          (!nextArticle || !foundMappings?.includes(nextArticle.permalink)) &&
          !fetchingForRef.current.includes(String(article.id))
        ) {
          fetchingForRef.current.push(String(article.id))
          fetchArticleAndInsertAfterId(foundMappings, String(article.id))
        }
      })
    }
  }, [articles, locale])
}
